import 'css-chunksrc/client/common/calendar/days/styles.scss';export default {
  "calendar": "_calendar_1f16n_1",
  "heading": "_heading_1f16n_7",
  "title": "_title_1f16n_18",
  "iconBox": "_iconBox_1f16n_32",
  "disabledIconBox": "_disabledIconBox_1f16n_46",
  "icon": "_icon_1f16n_32",
  "rightIcon": "_rightIcon_1f16n_63",
  "leftIcon": "_leftIcon_1f16n_67",
  "week": "_week_1f16n_71",
  "weekItem": "_weekItem_1f16n_78",
  "dayName": "_dayName_1f16n_82",
  "dayList": "_dayList_1f16n_94",
  "day": "_day_1f16n_82",
  "selectedDay": "_selectedDay_1f16n_119",
  "disabledDay": "_disabledDay_1f16n_130",
  "footer": "_footer_1f16n_140",
  "clear": "_clear_1f16n_146",
  "button": "_button_1f16n_162",
  "main": "_main_1f16n_174"
};